export var ItemType;

(function (ItemType) {
  ItemType["PageNumber"] = "PageNumber";
  ItemType["PrevPage"] = "PrevPage";
  ItemType["NextPage"] = "NextPage";
  ItemType["Separator"] = "Separator";
})(ItemType || (ItemType = {}));